import {extend} from 'colord';
import labPlugin from 'colord/plugins/lab';

extend([labPlugin]);
